/* global axios */
import ApiClient from './ApiClient';

// Pastas Spam/Lixo eletrônico e Lixeira lidas ao vivo no servidor de e-mail do cliente.
class EmailFoldersAPI extends ApiClient {
  constructor() {
    super('email_folders', { accountScoped: true });
  }

  inboxes() {
    return axios.get(`${this.url}/inboxes`);
  }

  list(params) {
    return axios.get(this.url, { params });
  }

  message(params) {
    return axios.get(`${this.url}/message`, { params });
  }

  attachment(params) {
    return axios.get(`${this.url}/attachment`, {
      params,
      responseType: 'blob',
    });
  }

  move(payload) {
    return axios.post(`${this.url}/move`, payload);
  }

  // Antecipa a leitura IMAP da Caixa de Entrada; sem inboxId, de todas as caixas.
  sync(inboxId) {
    return axios.post(`${this.url}/sync`, inboxId ? { inbox_id: inboxId } : {});
  }
}

export default new EmailFoldersAPI();
